import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Chop Array",
  url: "chop-array",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
  * @param {Any[]} arr
  * @param {number} k
  * @return {Any[][]}
  */
      
  /**
  * Do not change this function body
  * Do your changes within the function 
  */
  
  return function chopArr(arr, k) {
    // your code goes here        
  };
`,
};

export default info;
